import { HTMLAttributes } from "react";

export default function Adonis(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="5" width="36" height="36" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 24C0 43.3564 4.64362 48 24 48C43.3564 48 48 43.3564 48 24C48 4.64362 43.3564 0 24 0C4.64362 0 0 4.64362 0 24ZM9.678 28.9856L17.2061 11.8778C18.4762 8.994 20.9205 7.42987 24 7.42987C27.0795 7.42987 29.5234 8.99362 30.7942 11.8774L38.322 28.9856C38.664 29.8166 38.9573 30.8921 38.9573 31.8206C38.9573 36.0731 35.9756 39.0548 31.7228 39.0548C30.2745 39.0548 29.124 38.6854 27.9596 38.3111C26.7664 37.9279 25.5585 37.5397 24 37.5397C22.4595 37.5397 21.222 37.9313 20.0051 38.3164C18.8284 38.6888 17.6707 39.0548 16.2772 39.0548C12.0247 39.0548 9.04275 36.0735 9.04275 31.821C9.04275 30.8921 9.33638 29.8166 9.67838 28.9856H9.678ZM24 14.8594L16.5701 31.6744C18.7699 30.6476 21.3116 30.159 24 30.159C26.5909 30.159 29.2301 30.6476 31.332 31.674L24 14.8597V14.8594Z"
        fill="#5A45FF"
      />
    </svg>
  )
}
